"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.verificationRegExp = exports.emailRegExp = void 0;
// Email address input validation
var emailRegExp = exports.emailRegExp = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i;

// Verify validation code input sent from Cognito
var verificationRegExp = exports.verificationRegExp = /^[0-9]{6,6}$/;